const BeforeAfter = () => {
	return (
		<section className="relative pb-6 pt-10">
			<img
				src="/images/landingpage/heroCube.webp"
				className="absolute -right-[300px] top-0 max-w-[700px] opacity-40 blur-lg lg:opacity-100"
				alt="PagePilot.ai Decoration"
				width="700"
				height="700"
			/>
			<img
				src="/images/landingpage/heroSphere.webp"
				className="absolute -left-0 top-0 hidden max-w-[400px] blur-lg xl:flex"
				alt="PagePilot.ai Decoration"
				width="400"
				height="400"
			/>

			<div className="container-lp relative z-10 mx-auto">
				<div className="mx-auto flex max-w-6xl flex-col gap-6 px-4">
					<h2 className="text-transparent mx-auto bg-clip-text text-center text-3xl font-extrabold lg:text-5xl lg:leading-[60px]">
						<span className="text-transparent bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">
							How we{' '}
						</span>

						<span className="text-transparent bg-gradient-to-b from-white from-30% to-[#7496F8] bg-clip-text">
							transform{' '}
						</span>

						<span className="text-transparent bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">
							a low converting product page and make it a winner
						</span>
					</h2>

					<div className="mx-auto max-w-[350px] text-center text-lg text-white md:max-w-3xl lg:text-xl">
						Why spend hours building a product page only to watch it fail? With PagePilot, turn it into a money-maker in
						minutes.
					</div>
				</div>

				<div className="relative grid grid-cols-1 gap-6 pt-10 lg:grid-cols-2 lg:gap-0">
					<div className="card-bg relative z-10 mt-auto flex w-full flex-col bg-black/30 p-6 backdrop-blur-xl before:border-r-0 lg:rounded-r-none">
						<div className="px-8 pb-6 pt-6">
							<h3 className="mb-8 text-center text-2xl font-medium text-white">Your current product page</h3>

							<div className="relative mb-10 flex flex-col gap-2 overflow-hidden rounded-lg">
								<div className="to-transparent absolute bottom-0 left-0 right-0 h-[200px] w-full bg-gradient-to-t from-[#272943]"></div>
								<img
									src="/images/landingpage/beforePagePilot.webp"
									className="w-full rounded-xl"
									alt="Dropshipping Product Page Example"
									width="484"
									height="431"
								/>
							</div>

							<ul className="flex flex-col gap-2">
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-red-700" viewBox="-3.5 0 19 19" xmlns="http://www.w3.org/2000/svg">
										<path d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										low conversion rate
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-red-700" viewBox="-3.5 0 19 19" xmlns="http://www.w3.org/2000/svg">
										<path d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">no social proof</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-red-700" viewBox="-3.5 0 19 19" xmlns="http://www.w3.org/2000/svg">
										<path d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										low-impact, boring copywriting
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-red-700" viewBox="-3.5 0 19 19" xmlns="http://www.w3.org/2000/svg">
										<path d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										burning $$$ on ads without sales
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-red-700" viewBox="-3.5 0 19 19" xmlns="http://www.w3.org/2000/svg">
										<path d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										3 hours to build
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-red-700" viewBox="-3.5 0 19 19" xmlns="http://www.w3.org/2000/svg">
										<path d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">$50 per product</span>
								</li>
							</ul>
						</div>
					</div>

					<div className="card-bg absolute left-0 right-0 top-1/2 z-20 mx-auto mt-10 flex h-14 w-14 items-center justify-center rounded-full bg-bluePrimary text-xl font-bold text-white">
						VS
					</div>

					<div className="card-bg relative top-10 z-10 flex w-full flex-col border border-green-700 bg-black/30 p-6 backdrop-blur-xl md:top-10 md:mt-20 md:py-16 lg:mt-0">
						<div className="relative px-8 pb-6 pt-6">
							<h3 className="mb-8 text-center text-3xl font-semibold text-white">Using PagePilot.ai 🤑</h3>

							<div className="relative mb-10 overflow-hidden rounded-2xl">
								<div className="to-transparent absolute bottom-0 left-0 right-0 h-[100px] w-full bg-gradient-to-t from-[#272943] via-[#272943]/70"></div>
								<video
									src="https://cdn.shopify.com/videos/c/o/v/a83ff33d85ce4fd49dc9f9d6faf557eb.mp4"
									className="rounded-2xl"
									loop
									autoPlay
									playsInline
									muted
									title="PagePilot.ai Product Page Demo"
									aria-label="How PagePilot.ai works? Product Page Generation Demo"
									preload="metadata"></video>
							</div>

							<ul className="flex flex-col gap-2">
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-green-400" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<g data-name="Layer 2">
											<g data-name="checkmark">
												<rect width="24" height="24" opacity="0"></rect>
												<path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z"></path>
											</g>
										</g>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg">
										<strong className="font-bold">3x</strong> conversion rate
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-green-400" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<g data-name="Layer 2">
											<g data-name="checkmark">
												<rect width="24" height="24" opacity="0"></rect>
												<path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z"></path>
											</g>
										</g>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg">
										<strong className="font-bold">trust-building</strong> reviews
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-green-400" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<g data-name="Layer 2">
											<g data-name="checkmark">
												<rect width="24" height="24" opacity="0"></rect>
												<path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z"></path>
											</g>
										</g>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg">
										emotive, compelling <strong className="font-bold">copywriting</strong>
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-green-400" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<g data-name="Layer 2">
											<g data-name="checkmark">
												<rect width="24" height="24" opacity="0"></rect>
												<path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z"></path>
											</g>
										</g>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg">
										<strong className="font-bold">positive ROAS</strong> on each product tested
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-green-400" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<g data-name="Layer 2">
											<g data-name="checkmark">
												<rect width="24" height="24" opacity="0"></rect>
												<path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z"></path>
											</g>
										</g>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg">
										<strong className="font-bold">1 minute</strong> to build
									</span>
								</li>
								<li className="flex md:items-center">
									<svg className="h-6 w-6 fill-green-400" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<g data-name="Layer 2">
											<g data-name="checkmark">
												<rect width="24" height="24" opacity="0"></rect>
												<path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z"></path>
											</g>
										</g>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg">
										<strong className="font-bold">$0.78</strong> cost per product
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BeforeAfter;
